<template>
	<div class="Der__Aufbau">
		<div class="container">
			<h1>{{ $t('navigationAufbau.aufbau.title') }}</h1>
			<div class="row align-items-center">
				<div class="py-5 col-9">
					<div class="mb-3">
						{{ $t('navigationAufbau.aufbau.text') }}
					</div>
					<div class="mb-3">
						{{ $t('navigationAufbau.aufbau.text2') }}
					</div>
				</div>
			</div>
		</div>
		<div class="container-fluid">
			<div class="container py-5">
				<h4>
					{{ $t('navigationAufbau.komponentenpyramide.title') }}
				</h4>
				<div class="row align-items-center d-flex">
					<div class="col-9">
						<div class="mb-3">
							{{ $t('navigationAufbau.komponentenpyramide.text') }}
						</div>
						<div class="Kompetenzpyramide mb-3 text-center">
							<img :src="kompetenzpyramide" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="container-fluid">
			<div class="container py-5">
				<h4>
					{{ $t('navigationAufbau.toolsTargetsTactics.title') }}
				</h4>
				<div class="row align-items-center d-flex">
					<div class="col-9">
						<div class="mb-3">
							{{ $t('navigationAufbau.toolsTargetsTactics.text.absatz1') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationAufbau.toolsTargetsTactics.text.absatz2') }}
							<router-link :to="{ name: 'Grad1Infight' }">{{
								$t('navigationAufbau.toolsTargetsTactics.text.absatz2a')
							}}</router-link>
							{{ $t('navigationAufbau.toolsTargetsTactics.text.absatz2b') }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="container-fluid">
			<div class="container py-5">
				<h4>
					{{ $t('navigationAufbau.attributes.title') }}
				</h4>
				<div class="row align-items-center d-flex">
					<div class="col-9">
						<div class="mb-3">
							{{ $t('navigationAufbau.attributes.text.absatz1') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationAufbau.attributes.text.absatz2') }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="container-fluid">
			<div class="container py-5">
				<h4>
					{{ $t('navigationAufbau.attitudes.title') }}
				</h4>
				<div class="row align-items-center d-flex">
					<div class="col-9">
						<div class="mb-3">
							{{ $t('navigationAufbau.attitudes.text.absatz1') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationAufbau.attitudes.text.absatz2') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationAufbau.attitudes.text.absatz3') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationAufbau.attitudes.text.absatz4') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationAufbau.attitudes.text.absatz5') }}
						</div>
						<div class="system-action-button">
							<yellow-button
								:title="$t('navigationAufbau.buttons.button1')"
								pathName="Ausbildungsgrade"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import kompetenzpyramide from '@/assets/kompetenzpyramide_weiß.png'
import YellowButton from '@/components/YellowButton.vue'

export default {
	name: 'Aufbau',
	components: {
		YellowButton
	},
	data() {
		return {
			kompetenzpyramide: kompetenzpyramide
		}
	},
	i18n: {
		messages: {
			de: require('@/i18n/de/de_aufbau.json'),
			en: require('@/i18n/en/eng_aufbau.json')
		}
	}
}
</script>

<style scoped lang="stylus">

.Kompetenzpyramide {
	background-color: rgba(0,0,0,0.4);
    padding-top: 25px;
    padding-bottom: 25px;
}

img {
	width: 400px;
}

.system-action-button {
	display: flex;
	justify-content: center;
	margin-top: 6vh;
}
</style>
